import type { MutateOptions, UseMutationOptions, UseMutationResult } from '@tanstack/react-query';

export type ActionOptions<TArgs, TResult> = Omit<
  UseMutationOptions<TResult, Error, TArgs, unknown>,
  'mutationFn'
>;

export type ActionHook<TArgs, TResult> = [
  (args?: TArgs, options?: MutateOptions<TResult, Error, TArgs, unknown>) => Promise<TResult>,
  UseMutationResult<TResult, Error, TArgs, unknown>,
];

export function stableSerialize(value: unknown): string {
  if (Array.isArray(value)) return `[${value.map(stableSerialize).sort().join(',')}]`;
  if (value && typeof value === 'object') {
    return `{${Object.entries(value as Record<string, unknown>)
      .sort(([left], [right]) => left.localeCompare(right))
      .map(([key, entry]) => `${key}:${stableSerialize(entry)}`)
      .join(',')}}`;
  }
  return JSON.stringify(value);
}
